export default {
  content: `<p>
    中国的算力发展已形成以“智能算力为主导、全国一体化算力网为核心”的万亿级产业格局。 依托“东数西算”战略，中国正通过算力与电力的深度协同，将算力打造成像“水电”一样即开即用的公共基础设施。
</p>
<p>
    中国的算力发展正处于从“硬件跑马圈地”向“全国一体化运营与服务”深度转型的关键拐点。与美国由科技巨头（CapEx）纯市场化驱动的模式不同，中国算力呈现出独特的“政府顶层设计 + 市场创新活力”双轮驱动特征。
</p>`,
  t1: `<p>
    <strong>智算规模爆发式增长：</strong>截至2026年3月底，中国已建成的智能算力规模达到188.2万P（等效1882 EFLOPS），同比实现2.5倍的跨越式增长，智能算力成为绝对增量主体。
</p>
<p>
    <strong>“8+10+3”空间布局成型：</strong>以8大国家算力枢纽、10个国家数据中心集群、3个算电协同发展区域为重点的空间结构彻底确立，实现了全国算力资源的集约化、规模化发展。
</p>
<p>
    <strong>“20毫秒时延圈”打通：</strong>枢纽间建成145条干线光缆，全国各省份至8大枢纽的网络传输时延全部降至20毫秒以内，“千里之外、瞬间即达”的算网融合成为现实。
</p>
<p>
    <strong>应用由“训”转“推”并加速下沉：</strong>随着大模型全面落地，智算中心正从大模型“训练”主导切换为“推理”主导，算力正深度赋能工业、交通、政务等千行百业。
</p>
<p>
    <strong>核心现实挑战：</strong>算力供给存在结构性错配，部分西部节点因实体基础薄弱面临“建而不用、利用率低”的隐忧，而东部的高端、高可靠性算力依然紧张。同时，高端AI芯片的自主创新仍有突围空间。
</p>
<p>
    <br/>
</p>`,
  t2: `<p>
    <strong>全球最庞大的下游应用与 Token 消耗市场：</strong>中国拥有全球最密集的行业场景、最大的AI应用落地市场以及最快的 Token 消耗增速。全国日均 AI Token 调用量已飙升至 140万亿，两年前端增长超千倍，提供了巨大的市场消化力。&nbsp;
</p>
<p>
    <strong>举国体制下的“东数西算”与资源调度能力：</strong>中国拥有全球绝无仅有的“一盘棋”调度优势。通过“东数西算”八大枢纽和十大集群的布局，成功将东部高密度的算力需求引入西部风光绿电充裕的地区，有效规避了美国正在遭遇的“电网瘫痪”局部危机。
</p>
<p>
    <strong>降本增效的极速基建制造能力：</strong>依托中国完备的电子制造产业链，国内云厂商已实现全模块化数据中心架构（如阿里云 CUBE 5.0），将大型 AIDC 的交付工期从行业传统的 1年 极限缩短至 100天，且建设成本降低 10%。
</p>
<p>
    <br/>
</p>`,
  t3: `<p>
    <strong>结构性失衡，呈现“边缺边闲”的尴尬状态:</strong>
</p>
<p>
    <strong>分子与分母的错配：</strong>虽然总规模庞大，但国内智算中心平均有效利用率不足 30%。
</p>
<p>
    <strong>低端过剩，高端仍缺：</strong>中低端和碎片化算力大量闲置，而能够稳定承载万亿参数超大模型预训练的高质量、紧耦合、极低时延的高端算力依然高度短缺。
</p>
<p>
    <strong>端到端交付与跨区域调度的技术瓶颈：</strong><br/>目前全国算力网完成了“资源可见（监测）”，但尚未完全实现“任务可达（交付）”。大模型训练对卡间高带宽、紧耦合通信要求极高，西部零散的空闲卡很难在物理上直接拼接来承载东部的核心训练任务，且跨区传输成本高、数据隐私合规限制多。
</p>
<p>
    <strong>国产软硬件生态（CUDA壁垒）最难啃：</strong><br/>尽管华为昇腾、海光等硬件性能迭代极快，但英伟达的 CUDA 生态在全球开发者中积淀深厚。国产算力在底层软件栈、算子库适配以及大模型深度优化上面临巨大的生态迁移壁垒，形成“硬件易造，生态难建”的局面。
</p>
<p>
    <br/>
</p>`,
  t4: `<p>
    <strong>从“硬件交付”转向“Token 租赁与服务运营”</strong><br/>算力正在变成像水、电一样即取即用的公共资源。厂商不再仅仅卖服务器，三大运营商及算力硬件巨头正全面转向“Token工厂”模式和国家超算互联网服务。
</p>
<p>
    <strong>AI 异构算力池化爆发</strong><br/>为了打破不同品牌、不同架构芯片的硬件孤岛，国内加速采用“AI异构算力池化平台”，实现华为昇腾、海光DCU、摩尔线程、寒武纪等多家国产芯片在同一集群内的混合部署和无感知调用。
</p>
<p>
    <strong>产业链的“逆生长”补壁</strong><br/>受外部地缘政治挤压，中国计算产业正在走一条“早期整机集成—后期反向攻克底层芯片、互联拓扑、算子库（如DTK、FlagOS）”的逆生长自主化路线，加速实现全栈自主可控。
</p>
<p>
    <br/>
</p>`,
};
